import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

let user = JSON.parse(localStorage.getItem("user"));

if (user) {
  axios.defaults.headers.common = {
    Authorization: "Bearer " + user.token,
  };
}

axios.interceptors.response.use(
  (res) => {
      return res;
  },
  (error) => {
    return error;
  }
);

export default axios;